import { useQuery } from "@tanstack/react-query";
import { reportKeys } from "@/lib/query";

export interface ComplianceReport {
  total: number;
  byStatus: Record<string, number>;
  passRate: number;
  complete: number;
  inProgress: number;
  blocked: number;
  assigned: number;
  totalInScope: number;
  remainingProjects: number;
}

export function useComplianceReport() {
  return useQuery({
    queryKey: reportKeys.compliance,
    queryFn: async (): Promise<ComplianceReport> => {
      const res = await fetch("/api/reports/compliance");
      if (!res.ok) throw new Error("Failed to fetch compliance report");
      const json = await res.json();
      return json.data;
    },
  });
}
